export const Fields = Object.freeze({
  id: 'id',
  subjectName: 'Предмет',
  pairTime: 'Время',
  lessonTypeName: 'Тип урока',
  departmentName: 'Кафедра',
  dayName: 'День недели',
  weekNumber: 'Номер недели',
  groupTypeName: 'Тип группы',
  lectorName: 'Лектор',
  lectorId: 'Идентификатор лектора',
  lectorsForCurrentUser: 'Лектор',
  auditoryNumber: 'Аудитория',
  locationAddress: 'Адрес',
  semester: 'Семестр',
  courseNumber: 'Курс',
  speciality: 'Специальность',
  academicYear: 'Год',
  groupStream: 'Поток',
  studyGroup: 'Группа',
  subgroup: 'Подгруппа',
  stream: 'Поток',
  lessonType: 'Тип занятий',
  date: 'Дата',
  startDate: 'Начальная дата',
  endDate: 'Конечная дата',
  originalSubjectName: 'Предмет из справочника',
  disciplineOriginalId: 'Идентификатор предмета'
})

export const FieldsEng = Object.freeze({
  id: 'id',
  subjectName: 'Subject',
  pairTime: 'Time',
  lessonTypeName: 'Lesson type',
  departmentName: 'Department',
  dayName: 'Day of week',
  weekNumber: 'Number of week',
  groupTypeName: 'Group type',
  lectorName: 'Lecturer',
  lectorId: 'Identifier lecturer',
  lectorsForCurrentUser: 'Lecturer',
  auditoryNumber: 'Сlassroom/Auditorium',
  locationAddress: 'Address',
  semester: 'Semester',
  courseNumber: 'Course',
  speciality: 'Speciality',
  academicYear: 'Year',
  groupStream: 'Flow',
  studyGroup: 'Group',
  subgroup: 'Subgroup',
  stream: 'Flow',
  lessonType: 'Class Type',
  date: 'Date',
  startDate: 'Start date',
  endDate: 'End date'
})

export const Models = Object.freeze({
  auditoryNumber: 'auditoryNumber',
  dayName: 'dayName',
  departmentName: 'departmentName',
  groupTypeName: 'groupTypeName',
  lectorName: 'lectorName',
  lectorsForCurrentUser: 'lectorsForCurrentUser',
  locationAddress: 'locationAddress',
  pairTime: 'pairTime',
  studyGroup: 'studyGroup',
  subgroup: 'subgroup',
  subjectName: 'subjectName',
  weekNumber: 'weekNumber',
  groupStream: 'groupStream',
  lessonType: 'lessonType',
  stream: 'stream',
  speciality: 'speciality',
  courseNumber: 'courseNumber',
  academicYear: 'academicYear',
  semester: 'semester',
  date: 'date',
  subgroupLiterra: 'subgroupLiterra',
  disciplineOriginal: 'disciplineOriginal',
  disciplineGenerated: 'disciplineGenerated',
  pivotFieldArrangement: 'pivotFieldArrangement'
})

export const ScheduleStatus = Object.freeze({
  uploaded: 1,
  agreed: 3,
  published: 4,
  verified: 2
})

export const PivotFieldArrangement = Object.freeze({
  x: 1,
  y: 2
})

export const DayWeek = Object.freeze({
  monday: 'ПН',
  tuesday: 'ВТ',
  wednesday: 'СР',
  thursday: 'ЧТ',
  friday: 'ПТ',
  saturday: 'СБ'
})

export const DayWeekEng = Object.freeze({
  monday: 'Mon',
  tuesday: 'Tue',
  wednesday: 'Wed',
  thursday: 'Thu',
  friday: 'Fri',
  saturday: 'Sat'
})

export const SemesterEng = Object.freeze({
  1: 'Fall semester',
  2: 'Spring semester'
})
